import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Selects all of the duplicate employees in the selection lookup, and then
 * discards any unsaved changes.
 */
export const selectDuplicates = store.effects.create(
  (feature: Plugin['feature'], collection: Plugin['collection']) =>
    feature.actions.selectDuplicates.relay((forwardTo, { target }) =>
      feature.selectors.duplicates.asObservable.pipe(
        rxjs.take(1),
        rxjs.map(duplicates =>
          forwardTo(
            collection.plugins.selectionPlugin.applied.actions
              .putInSelectionLookup,
            {
              input: {
                key: target,
                value: {
                  add: duplicates.map(({ id }) => id),
                },
              },
              /**
               * NOTE: This handles the case where the duplicates are already
               * selected because the selection plugin cancels the set action if
               * the value is the same as the current value. In this case, we
               * still want to discard any unsaved changes to the employees, so
               * we handle the cancellation case by dispatching the discard
               * action.
               */
              onCancellation: (reason, source) =>
                collection.plugins.editingPlugin.feature.actions.discard
                  .from(source)
                  .dispatch({ current: true }),
              onSuccess: (innerResult, outerResult, source) =>
                collection.plugins.editingPlugin.feature.actions.discard
                  .from(source)
                  .dispatch({ current: true }),
            },
          ),
        ),
      ),
    ).asObservable,
)
